var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.875C5.37868 4.875 4.875 5.37868 4.875 6C4.875 6.62132 5.37868 7.125 6 7.125C6.62132 7.125 7.125 6.62132 7.125 6C7.125 5.37868 6.62132 4.875 6 4.875Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.75C4.69111 2.75 3.514 3.27569 2.66581 3.92668C2.24116 4.25259 1.89272 4.61456 1.64825 4.96684C1.40843 5.3124 1.25 5.67577 1.25 6C1.25 6.32423 1.40843 6.6876 1.64825 7.03316C1.89272 7.38544 2.24116 7.74741 2.66581 8.07332C3.514 8.72431 4.69111 9.25 6 9.25C7.30889 9.25 8.486 8.72431 9.33419 8.07332C9.75884 7.74741 10.1073 7.38544 10.3518 7.03316C10.5916 6.6876 10.75 6.32423 10.75 6C10.75 5.67577 10.5916 5.3124 10.3518 4.96684C10.1073 4.61456 9.75884 4.25259 9.33419 3.92668C8.486 3.27569 7.30889 2.75 6 2.75ZM4.125 6C4.125 4.96447 4.96447 4.125 6 4.125C7.03553 4.125 7.875 4.96447 7.875 6C7.875 7.03553 7.03553 7.875 6 7.875C4.96447 7.875 4.125 7.03553 4.125 6Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeon);
export default __webpack_public_path__ + "static/media/eyeon.1e417ef61425571e804bf5a8b17107c4.svg";
export { ForwardRef as ReactComponent };